import _ from "lodash/fp";
import { useSelector } from "react-redux";

const useError = () => {
    const serverError = useSelector((store) => store.error);

    return serverError ? { message: _.get(["message"], serverError) } : null;
};
export default useError;
